import React, { useState, useEffect } from 'react'
import {Grid, Container, Stack, AppBar, IconButton,CircularProgress} from '@mui/material'
import {Logout} from '@mui/icons-material'
import WbButton from '../../components/common/WbButton'
import { staffFour, staffOne, staffThree, staffTwo,staffDefault } from '../../components/assets/images'
import { useNavigate  } from 'react-router-dom';
import paths from '../../routes/paths'
import { safeSpaceApi } from '../../services/api/safespace/safeSpaceApi'
import { toPupilViewableAvatarUrl } from '../../utils/staffAvatar'
import unifiedLogout from '../../utils/unifiedLogout'

export default function SelectStaff() {
  const navigate = useNavigate();
  const [staffMembers, setStaffMembers] = useState([]);
  const [schoolHolidays, setschoolSettings] = useState([]);
   const [schoolSettings, setschoolHolidays] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [safeSpaceConfig, setSafeSpaceConfig] = useState({
    allowInPersonResponse: false,
    allowMessageResponse: false,
    isZoneOfRegulationEnabled: false,
    isSafeSpaceEnabled: false,
    isSimpleExperienceForAllStudents: false,
    messages: []
  });

  const isCurrentTimeInRange = (startTime, endTime) => {
    if (!startTime || !endTime) return false;
    
    const currentDate = new Date();
    const currentTime = currentDate.getHours() + ':' + currentDate.getMinutes() + ':' + currentDate.getSeconds();
    
    // Convert all to minutes for easy comparison
    const currentMinutes = currentTime.split(':').reduce((acc, time) => (60 * acc) + +time);
    const startMinutes = startTime.split(':').reduce((acc, time) => (60 * acc) + +time);
    const endMinutes = endTime.split(':').reduce((acc, time) => (60 * acc) + +time);
    
    return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
  };

  const [IsSchoolHoliday, setIsSchoolHoliday] = useState(false);
  const [schoolHolidayMessageEnabled, setSchoolHolidayMessageEnabled] = useState(false);
  const [schoolHolidayMessageContent, setSchoolHolidayMessageContent] = useState('');
  useEffect(() => {
    const fetchStaffMembers = async () => {
      try {
        setLoading(true);
        const pupilData = JSON.parse(localStorage.getItem('pupil') || '{}');
        const studentId = pupilData?.studentId;
        const schoolId = pupilData?.schoolId;
        const groupId = pupilData?.groupId;
        const isMAT = (pupilData?.groupId == null || pupilData?.groupId === "" || pupilData?.groupId === 0) ? false : true;
        safeSpaceApi.getStaffByStudentId(studentId, schoolId)
          .then((response) => {
            if (response != null) {
              setStaffMembers(response);
              // code to get the safe space settings
              safeSpaceApi.getSafeSpaceSettings(schoolId, groupId, isMAT)
                .then((settings) => {
                  if (settings != null) {
                    setschoolSettings(settings);
                    setSafeSpaceConfig({
                      allowInPersonResponse: settings.allowInPersonResponse,
                      allowMessageResponse: settings.allowMessageResponse,
                      isZoneOfRegulationEnabled: settings.isZoneOfRegulationEnabled,
                      isSafeSpaceEnabled: settings.isSafeSpaceEnabled,
                      isSimpleExperienceForAllStudents: settings.isSimpleExperienceForAllStudents,
                      messages: settings.messages.map(msg => ({
                        isEnabled: msg.isEnabled,
                        messageContent: msg.messageContent,
                        messageType: msg.messageType,
                        outOfHoursStartTime: msg.outOfHoursStartTime,
                        outOfHoursEndTime: msg.outOfHoursEndTime,
                        schools: msg.schools
                      }))
                    });
                    localStorage.setItem('safeSpaceConfig', JSON.stringify(settings));

                    // Check for school holiday message config
                    const schoolHolidayMsg = settings.messages.find(msg => msg.messageType === 2);
                    if (schoolHolidayMsg) {
                      setSchoolHolidayMessageEnabled(!!schoolHolidayMsg.isEnabled);
                      const holidayMsgContent = (schoolHolidayMsg.messageContent || '').replace(/\[Adult Name\]/gi, 'staff');
                      setSchoolHolidayMessageContent(holidayMsgContent);
                    }
                    setLoading(false);
                  }
                })
                .catch((error) => { });
              // code to get the holiday Lists
              safeSpaceApi.getHolidays(schoolId, groupId)
                .then((holidays) => {
                  //debugger;
                  if (holidays != null) {
                    //debugger;
                    setschoolHolidays(holidays);
                    localStorage.setItem('safeSpaceHolidays', JSON.stringify(holidays));

                    // Check if today is a school holiday
                    const today = new Date();
                    const isHoliday = holidays.some(holiday => {
                      const start = new Date(holiday.startDate);
                      const end = new Date(holiday.endDate);
                      return today >= start && today <= end;
                    });
                    setIsSchoolHoliday(isHoliday);
                    setLoading(false);
                  }
                })
                .catch((error) => { });
              setLoading(false);
            }
          })
          .catch((error) => { });
      } catch (err) {
        setError('Failed to fetch staff members');
        setLoading(false);
      }
    };
    fetchStaffMembers();
  }, []);

  // if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <>
      <AppBar className="header">
        <Container maxWidth="xxl">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <div className="logo">
              <span>Welbee</span>
            </div>
            <div>
              <nav>
                <WbButton
                  onClick={() => {
                    unifiedLogout()
                  }}
                  CustomButtonText="Logout"
                />                  
              </nav>
            </div>
          </Stack>
        </Container>
      </AppBar>
      <div className="main-container">
        <Container maxWidth="lg"> 
        {loading===true? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '500px' }}>
            <CircularProgress />
          </div>
        ) : (
          <div className="select-staff">
            <Grid container mt={4}>
              <Grid item lg={12} md={12} sm={12} xs={12} textAlign="left">
                {/* School holiday message logic */}
                {IsSchoolHoliday && !schoolHolidayMessageEnabled ? (
                  <div style={{
                    backgroundColor: '#FFF3CD',
                    padding: '16px',
                    borderRadius: '6px',
                    marginBottom: '30px',
                    color: '#856404',
                    border: '2px solid #FFEEBA',
                    fontWeight: 600,
                    fontSize: 18,
                    textAlign: 'center',
                  }}>
                    It is the school holiday, so you are not able to use safe space. If you need urgent help, you can reach out to: Childline on 0800 11111 or via childline.org.uk Or text The Mix on 85258.
                  </div>
                ) : (
                  <>
                    {IsSchoolHoliday && schoolHolidayMessageEnabled && schoolHolidayMessageContent && (
                      <div style={{
                        backgroundColor: '#FFF3CD',
                        padding: '12px',
                        borderRadius: '4px',
                        marginBottom: '20px',
                        color: '#856404',
                        border: '1px solid #FFEEBA'
                      }}>
                        {schoolHolidayMessageContent}
                      </div>
                    )}
                    {/* Out of hours message with null check */}
                    {(() => {
                      const outOfHoursMessage = safeSpaceConfig?.messages?.find(msg => msg.messageType === 1);
                      if (!outOfHoursMessage || !outOfHoursMessage.isEnabled || !outOfHoursMessage.messageContent) return null;
                      let message = outOfHoursMessage.messageContent;
                      message = message
                        .replace(/\[Adult Name\]/gi, 'staff')
                        .replace(/\[From\]/gi, outOfHoursMessage?.outOfHoursStartTime || '')
                        .replace(/\[To\]/gi, outOfHoursMessage?.outOfHoursEndTime || '');
                      // Show out of hours message if outOfHoursMessage is enabled, regardless of holiday
                      // But only show if current time is out of hours
                      const isOutOfHours = isCurrentTimeInRange(
                        outOfHoursMessage?.outOfHoursStartTime,
                        outOfHoursMessage?.outOfHoursEndTime
                      );
                      if (isOutOfHours) {
                        return (
                          <div style={{
                            backgroundColor: '#FFF3CD',
                            padding: '12px',
                            borderRadius: '4px',
                            marginBottom: '20px',
                            color: '#856404',
                            border: '1px solid #FFEEBA'
                          }}>
                            Out Of Office hours : {message}
                          </div>
                        );
                      }
                      return null;
                    })()}
                    <h1 className='select-staff-heading'>Who do you want to speak with?</h1>
                  </>
                )}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
                <Stack>
                  <Grid container rowGap={8} pb={5} justifyContent="center">
                    {(!IsSchoolHoliday || schoolHolidayMessageEnabled) && staffMembers.map((staff, index) => {
                      const outOfHoursMessage = safeSpaceConfig?.messages?.find(msg => msg.messageType === 1);
                      const isOutOfHours = isCurrentTimeInRange(
                        outOfHoursMessage?.outOfHoursStartTime,
                        outOfHoursMessage?.outOfHoursEndTime
                      );
                      const isDisabled = outOfHoursMessage?.isEnabled && isOutOfHours;
                      const disabledMessage = isDisabled ?
                        `You can not send a message to staff from ${outOfHoursMessage.outOfHoursStartTime} to ${outOfHoursMessage.outOfHoursEndTime}` : '';
                      return (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={staff.responderId}>
                          <div className='staff-member'>
                            <img
                              // Routed through Custom-Api's anonymous artifact proxy: the raw
                              // logoFileURL points at Admin-Api, which 401s for a pupil.
                              src={toPupilViewableAvatarUrl(staff.logoFileURL) || staffDefault
                                // (staff.prefix === 'Mr' ? [staffThree][Math.floor(Math.random() * 2)] :
                                //   staff.prefix === 'Miss' ? [staffTwo, staffTwo, staffFour][Math.floor(Math.random() * 2)] :
                                //   [staffOne, staffTwo, staffThree, staffFour][index]) || staffOne
                              }
                              alt={staff.firstName + ' ' + staff.lastName}
                              className='staff-member-image'
                            />
                            <h2>{staff.prefix || 'Mx'} {staff.userName || staff.lastName || staff.firstName || 'Unknown'}</h2>
                            <WbButton
                              CustomButtonText={'Start Conversation'}
                              // disabled={isDisabled}
                              // title={disabledMessage}
                              onClick={() => {
                                localStorage.setItem('selectedStaff', JSON.stringify({
                                  responderId: staff.responderId,
                                  firstName: staff.firstName,
                                  lastName: staff.lastName,
                                  logoFileURL: staff.logoFileURL,
                                  staffName: `${staff.prefix || 'Mx'}.${staff.userName || staff.lastName || staff.firstName || 'Unknown'}`,
                                  prefix: staff.prefix,
                                  userName: staff.userName
                                }));
                                const isSimpleExperience = safeSpaceConfig?.isSimpleExperienceForAllStudents;
                                navigate(isSimpleExperience ? paths.selectZone : paths.newConversation, {
                                  state: { staffId: staff.responderId }
                                });
                              }}
                            />
                          </div>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Stack>
              </Grid>
            </Grid>
          </div>
        )}
        </Container>
      </div>
    </>    
  )
}
